<template>
  <section class="page">
    <div class="foreground">
      <h1>Anugerah Christian Rompis</h1>
      <p>Web Developer<br />Front-end &middot; Back-end &middot; Full-stack</p>
      <p>
        <ToolbarDiv>
          <FancyButton href="mailto:starleaf1@gmail.com"><div class="big">Contact me</div></FancyButton>
          <FancyButton href="https://www.upwork.com/freelancers/~01fbb6ea029aacda36"><div class="big">Hire me on Upwork</div></FancyButton>
        </ToolbarDiv>
        <ToolbarDiv class="social-buttons">
          <a title="My GitHub profile" href="https://github.com/starleaf1">
            <img class="social-button" alt="GitHub logo" src="@/assets/img/github-logo.png" />
          </a>
          <a title="My StackOverflow page" href="https://stackoverflow.com/users/2190916/starleaf1">
            <img class="social-button" src="@/assets/img/stackoverflow-logo.png" alt="StackOverflow logo" />
          </a>
          <a title="My LinkedIn profile" href="https://www.linkedin.com/in/anugerah-rompis-04053727/">
            <img class="social-button" src="@/assets/img/linkedin-logo.png" alt="LinkedIn logo" />
          </a>
        </ToolbarDiv>
      </p>

    </div>
    <div class="please-scroll-down">
      <p>Scroll down to learn more</p>
      <p>&#65086;</p>
    </div>
  </section>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import FancyButton from '@/components/FancyButton.vue'
import ToolbarDiv from '../components/ToolbarDiv.vue'

export default defineComponent({
  setup() {
  },
  components: { FancyButton, ToolbarDiv }
})
</script>

<style scoped>
.social-buttons {
  margin-top: 2rem
}
.social-button {
  height: 32px;
}
.please-scroll-down {
  width: 100%;
  position: absolute;
  bottom: 5px;
}
.please-scroll-down p {
  margin: 0;
}

.page {
  background-image: linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.55)), url('@/assets/img/top-bg.png');
  background-color: transparent;
  background-size: cover;
  height: 100vh;
}

.big {
  font-size: 1.25rem;
  margin: 0.5rem;
  font-weight: bolder;
}

.foreground {
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(3px);
  width: 100%;
  height: 100%;
}

p {
  text-align: center;
}

h1 {
  font-weight: heavy;
  text-align: center;
  font-size: 3rem;
}
</style>
